module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAmUlEQVR42t2WSw3AIBBEawAVFYCL9lIByKiNClgXSMEABjCwArZz20s/aUImKZO8E4eXTALMtO4bldsDMwtAQAMKCkj9hS6rdp0MQm+h2HMqiD2Fzd6jIPURfouAwBF6CpiJQq+YJ/QIWegV84Re8cITeiJbmNlCpQuHrlRBpF6LIS++jPZ4e4W/+oAre2IchBFFm4n8IUzlBGHcbiVUR6e7AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/welfare/video-icon.png
// module id = Zc1p
// module chunks = 216